export const sortListByAttribute = (list, attr) => {
  return list?.sort((a, b) => {
    if (!a[attr] || !b[attr]) return 0;
    if (a[attr] < b[attr]) return -1;
    if (a[attr] > b[attr]) return 1;
    return 0;
  });
};
